<template>
    <div v-if="open" id="adQuizProfitPopup" class="popupPage open">
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto d-flex flex-column">
                    <div class="header mb-5">
                        <a v-if="locked" class="close" style="opacity:0.2!important;"></a>
                        <a v-else @click.prevent="hide();btnSfx();" href="#" class="close"></a>
                    </div>
                    <template v-if="priceObj.type == 'WHEEL_OF_FORTUNE'">
                        <div class="m-auto pt-5 animate__animated animate__fadeIn">
                            <div class="mainbox m-auto">
                                <div class="spinBg"></div>
                                <div id="wheelBox" class="box">
                                    <div class="box1">
                                        <span v-for="(i, index) in priceObj.displayValues.slice(0, 4)" :key="index" :class="'span'+(index+1)">
                                            <b>{{ i.abbr(true) }}</b><img src="/images/challenges/token-white.png"/>
                                        </span>
                                    </div>
                                    <div class="box2">
                                        <span v-for="(i, index) in priceObj.displayValues.slice(4, 8)" :key="index" :class="'span'+(index+1)">
                                            <b>{{ i.abbr(true) }}</b><img src="/images/challenges/token-white.png"/>
                                        </span>
                                    </div>
                                </div>
                                <div v-if="giveaway" class="spinCenter giveaway">
                                    <div>{{ giveaway.multiplier }}</div>
                                </div>
                                <div v-else class="spinCenter"><img src="/images/home/win-wheel-star.png"></div>
                                <div v-if="showInfo || priceObj.predeterminedValue" class="awardInfo"><img src="/images/challenges/token-white.png"/><div>{{ priceObj.value.abbr(true) }}</div></div>
                            </div>
                            <div class="text-center pt-5 mb-4">
                                <b-button @click="spinWheel();btnSfx();" :disabled="locked || priceObj.predeterminedValue" size="lg" variant="primary">{{ $t('spin_wheel.spin_btn') }}</b-button>
                            </div>
                            <p class="text-center px-5">{{ $t('spin_wheel.info') }}</p>
                        </div>
                    </template>
                    <template v-else-if="priceObj.type == 'JACKPOT'">
                        <div class="m-auto text-center">
                            <div class="jackpot-box animate__animated animate__bounceIn">
                                <img src="/images/home/win-wheel-jackpot.png"/>
                                <h2>{{ priceObj.value.abbr(true) }}</h2>
                            </div>
                            <h5 class="px-5 animate__animated animate__delay-1s animate__fadeIn" v-html="$t('spin_wheel.jackpot_info', {profit: priceObj.value.abbr(true) })"></h5>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../api'

const AdQuizProfitPopup = Vue.component('adquiz-profit-popup', {
    props: {
        minCircles: { type: Number, default: 3 },
        maxCircles: { type: Number, default: 8 },
    },

    data() {
        return {
            open: false,
            locked: true,
            showInfo: false,
            indexDeg: [90,270,180,0,225,45,315,135],
            priceObj: {
                value: 0,
                type: '',
                displayValues: [],
                predeterminedValue: false
            }
        }
    },


    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show() {
            const $this = this;
            // load price
            api.adQuizProfit().then(res => {
                $this.open = true;
                $this.locked = false;
                $this.priceObj = res.data;
                
                // when is jackpot or already spined profit wheel
                if($this.priceObj.type == 'JACKPOT' || $this.priceObj.predeterminedValue){
                    $this.$store.dispatch('sound/sfx','Achievements');
                    setTimeout(() => {
                        $this.$emit('nextStep', $this.priceObj.value);
                        $this.hide();
                    }, 4000);
                }
            })
            .catch(err => {
                api.baseErrorHendler(err);
            });
        },

        hide() {
            this.open = false;
            this.locked = true;
            this.showInfo = false;
            let element = document.getElementById('wheelBox');
            if (element){
                element.style.transform = "rotate(22.5deg)";
                element.style.transition = "none ";
            }
        },  

        spinWheel(){
            if(this.locked) return;
            this.locked = true;
            
            const $this = this;
            let element = document.getElementById('wheelBox');
            let index = this.priceObj.displayValues.findIndex(x => x == this.priceObj.value);
            let circles = Math.floor(Math.random() * (this.maxCircles - this.minCircles)) + this.minCircles;
            let deg = (circles * 360) + this.indexDeg[index];

            element.style.transition = "all ease 5s";
            element.style.transform = "rotate("+deg+"deg)";

            setTimeout(() => {
                $this.$store.dispatch('sound/sfx','SpinDone');
            }, 5000);

            setTimeout(() => {
                $this.showInfo = true;
            }, 5300);

            setTimeout(() => {
                $this.$emit('nextStep', this.priceObj.value);
                $this.hide();
            }, 6500);
        },
    },

    computed: {
        giveaway(){
            return this.$store.state.giveaway.data;
        },
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    },
});

export default AdQuizProfitPopup
</script>